/**
 * 订单确认页地址
 */

import { Base64 } from 'js-base64';

/**
 * 获取购买页地址
 * @param {string} url buy页面地址
 * @param {object} config 产品配置
 * @returns {string} order url
 */
function getOrderUrl(url, config) {
  const params = encodeURIComponent(Base64.encode(JSON.stringify(config)));

  return url + `?orderData=${params}`;

}
export {getOrderUrl} ;


// WEBPACK FOOTER //
// ./lib/services/services/order.js